<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">意见反馈</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="isRead" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isReadArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>分类：</label>
          <el-select v-model="sortId" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in sortIdArray" :key="item.id" :label="item.sort" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <el-button type="primary" v-loading="updateLoading" @click="updateReadState">已查看&分类</el-button>
          <ElButtons type="success" icon="ChatDotRound" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="primary" v-loading="updateLoading" @click="editListSort" plain>编辑分类</el-button>
          <el-input v-model="searchBillValue" placeholder="请输入订单号" clearable style="width: 20em; margin-left: 16px;"/>
          <el-button style="margin-left: 8px;" type="success" @click="getSearchBill" v-loading="searchBillLoading"> 查询 </el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1" width="110"/>
          <el-table-column label="反馈人" v-if="checkColList.indexOf('反馈人') > -1">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column label="反馈图片" v-if="checkColList.indexOf('反馈图片') > -1" width="200">
            <template #default="scope">
              <el-space wrap>
                <el-image style="width: 48px; height: 48px" fit="cover" v-for="(item, index) in scope.row.adviceImgList" :key="item.id" :src="item.smallImg" @click="showImg(index, scope.row.adviceImgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="msg" label="反馈内容" v-if="checkColList.indexOf('反馈内容') > -1"></el-table-column>
          <el-table-column property="versionId" label="版本号" v-if="checkColList.indexOf('版本号') > -1"></el-table-column>
          <el-table-column property="" label="平台类型" v-if="checkColList.indexOf('平台类型') > -1">
            <template #default="scope">
              <p>{{scope.row.platformType==1?"Android":scope.row.platformType==2?"IOS":scope.row.platformType==3?"WEB":"--"}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="处理状态" v-if="checkColList.indexOf('处理状态') > -1">
            <template #default="scope">
              {{scope.row.isRead == 0?'未查看':scope.row.isRead == 1?'已查看':''}}
            </template>
          </el-table-column>
          <el-table-column property="sort" label="分类" v-if="checkColList.indexOf('分类') > -1"></el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import {getAdvicePageList, updateAdviceReadState, getAdviceListSort, getSearchBillInfo} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import isReadDialog from "@/views/feedback/components/isReadDialog";
import ListSortDialog from "@/views/feedback/components/ListSortDialog";
import SearchBillInfoDialog from "@/views/vip/components/SearchBillInfoDialog";

export default {
  name: "FeedbackOpinion",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {
      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      isReadArray: [
        {label: '不限', value: -1},
        {label: '未查看', value: 0},
        {label: '已查看', value: 1},
      ],
      isRead: 0,

      sortIdArray: [
        {sort: '不限', id: -1},
        {sort: '未做分类', id: 0},
      ],
      sortId: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '用户ID', value : 2},
        {label : '昵称', value : 3},
      ],
      searchType: 2,
      searchValue: '',

      //刷新组
      colList: ['时间', '反馈人', '反馈图片', '反馈内容', '版本号', '平台类型', '处理状态', '分类', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],

      //查询订单号
      searchBillValue: '',
      searchBillLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.isRead = 0;
      this.sortId = 0;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      this.userIdArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['isRead'] = this.isRead;
      param['sortId'] = this.sortId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAdvicePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    updateReadState() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '查看操作',
          component: isReadDialog,
          data: {
            idArray: this.idArray,
          },
          confirm: () => {
            for (let j = 0; j < this.idArray.length; j++) {
              for(let i = 0; i < this.pageDataList.length; i++ ) {
                if(this.idArray[j] == this.pageDataList[i]['id']) {
                  this.pageDataList.splice(i, 1);
                }
              }
            }
          }
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
      }
    },

    editListSort() {
      Dialog.open({
        title: '编辑分类',
        component: ListSortDialog,
        data: {

        },
        confirm: () => {

        }
      })
    },


    //图片预览
    showHeadImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['user_log'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }


    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.userIdArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    getSortList() {
      this.sortIdArray = [
        { sort:"不限", id:-1 },
        { sort:"未做分类", id:0 }
      ];
      let _this = this;
      getFormData(getAdviceListSort, {}).then((data) => {
        let { code, msg } = data;
        if(code == 200) {
          if (data.data.length > 0) {
            _this.sortIdArray = _this.sortIdArray.concat(data.data);
          }
        }
      })
    },

    getSearchBill() {
      if(!this.searchBillValue) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '订单号不能为空',
          type: 'warning'
        });
        return;
      }
      this.searchBillLoading = true
      let param = {};
      param['searchValue'] = this.searchBillValue;
      getFormData(getSearchBillInfo, param).then((data)=> {
        let {code, msg} = data;
        if (code == 200) {
          // console.log(data)
          Dialog.open({
            component: SearchBillInfoDialog,
            data: {
              userForm: data.data,
              width: '600px'
            },
            confirm: () => {
              // this.getPage()
            }
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchBillLoading = false
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getSortList()
  }
}
</script>

<style scoped>

</style>
